export const QUERY__VOUCHER_CONFIGS = 'voucher-configs';
export const QUERY__VOUCHER_CONFIG = 'voucher-config';
